package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsAction
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsState
import com.eladfinish.bible.contest.screens.mikud.ui.dialogs.MikudMenuRow
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogSelectableList
import dev.icerock.moko.resources.compose.localized

// TODO: it's almost the same as LoadMikudDialog
@Composable
internal fun LoadRemoteChapterCompletionDialog(
    state: BrowseTabsState.DialogState.RemoteSavedCompletions,
    onAction: (BrowseTabsAction) -> Unit,
) {
    BasicDialogWithTitle(
        title = state.title.localized(),
        onDismiss = { onAction(BrowseTabsAction.HideDialog) },
        onCancel = { onAction(BrowseTabsAction.HideDialog) },
    ) {
        val totalItems = state.items.size
        val itemsIndices = (0 until totalItems).toList()

        DialogSelectableList(
            list = itemsIndices,
            item = { index, _ ->
                val itemText = state.items[index]
                MikudMenuRow(
                    index = index,
                    text = itemText,
                    isPreset = true,
                )
            },
            onClick = { index, _ ->
                val blanksRecord = state.blanksRecords[index]
                onAction(BrowseTabsAction.LoadRemoteChapterCompletion(blanksRecord))
            }
        )
    }
}
